import { render, staticRenderFns } from "./LocationUsersViewTable.vue?vue&type=template&id=7c56d983&scoped=true"
import script from "./LocationUsersViewTable.vue?vue&type=script&lang=js"
export * from "./LocationUsersViewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c56d983",
  null
  
)

export default component.exports